import axios from 'axios';
import authHeader from './auth-header';


const API_URL = process.env.VUE_APP_API_URL + 'digitalio/';

class DigitalIOService {

    getBaliseDigitalIOs(baliseId) {
        return axios.get(
            API_URL + 'balise/' + baliseId,
            {
                headers: authHeader()
            }
        );
    }

    getDigitalIO(digitalIOId) {
        return axios.get(
            API_URL + digitalIOId,
            {
                headers: authHeader()
            }
        );
    }

    createDigitalIO(baliseId, data) {
        return axios.post(
            API_URL + 'balise/' + baliseId,
            data,
            {
                headers: authHeader()
            }
        );
    }

    updateDigitalIO(digitalIOId, data) {
        return axios.put(
            API_URL + digitalIOId,
            data,
            {
                headers: authHeader()
            }
        );
    }

    deleteDigitalIO(digitalIOId) {
        return axios.delete(
            API_URL + digitalIOId,
            {
                headers: authHeader()
            }
        );
    }
}

export default new DigitalIOService();